import React, { FC } from 'react';

import { ISvgProps } from '../Svg.types';
const CompatibilityReportGrid: FC<ISvgProps> = props => (
  <svg width={364} height={364} viewBox="0 0 364 364" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#E4E8E9">
      <path strokeWidth={4} d="M0 182h364M182 0v364" />
      <path
        strokeWidth={2}
        d="M134 0v364M86 0v364M38 0v364M0 134h364M0 230h364M0 278h364M0 326h364M0 86h364M0 38h364M230 0v364M278 0v364M326 0v364"
      />
    </g>
  </svg>
);

export default CompatibilityReportGrid;
